import script from "./CustomBackground.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomBackground.vue?vue&type=script&setup=true&lang=js"

import "./CustomBackground.vue?vue&type=style&index=0&id=686874ba&scoped=true&lang=css"

import exportComponent from "/Users/victoriengarrigues/Documents/Moonarch-DEV/code/moonarch-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-686874ba"]])

export default __exports__